import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";

function EnglishDatepicker({ value, onChange }) {
  return (
    <DatePicker
      value={value}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select English Date (AD)"
          fullWidth
          InputProps={{
            ...params.InputProps,
            style: {
              backgroundColor: "#fff",
              opacity: 1,         // Make sure it's not see-through
              color: "#222"
            }
          }}
          inputProps={{
            ...params.inputProps,
            style: {
              backgroundColor: "#fff",
              opacity: 1,
              color: "#222"
            }
          }}
        />
      )}
    />
  );
}

export default EnglishDatepicker;
